import { UFOExperience, ExperienceTypes, ExperiencePerformanceTypes } from '@atlassian/ufo';

// This is used to track help center dropdown experience
export const helpCenterFetchExperience = new UFOExperience('jsm-help-center-data-fetch', {
	type: ExperienceTypes.Experience,
	performanceType: ExperiencePerformanceTypes.InlineResult,
});
